<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .keypad-view {
    height: 100%;
    backdrop-filter: blur(2rem);
    padding: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 10;
    overflow: hidden;
    position: relative;

    .close-modal {
      background: transparent;
      border: none;
      cursor: pointer;
      left: 1rem;
      padding: 0;
      position: absolute;
      top: 1rem;
      user-select: none;

      i {
        color: white;
        font-size: 1.2rem;
      }

      &:focus {
        outline: 2px solid rgba(255, 255, 255, 0.5);
        outline-offset: 2px;
      }
    }
  }
</style>

<script>
  import { showToast } from "@sourcewhale/core";
  import KeypadUI from "../components/KeypadUI.svelte";
  import { diallerState } from "../diallerState.svelte";
  import { twilioManager } from "../utils/TwilioManager";

  // Handle closing the keypad view
  const handleClose = () => {
    diallerState.viewMode = "user";
  };

  // Handle digit press from keypad
  const handleDigitPress = (digit) => {
    if (!diallerState.activeCall) {
      showToast({
        title: "No active call",
        subtitle: "You must be on a call to use the keypad",
        type: "warning",
      });
      return;
    }

    try {
      diallerState.keypadInputDigits += digit;

      // Send digit through Twilio
      twilioManager.sendDigit(digit);
    } catch {
      showToast({
        title: "Failed to send digit",
        subtitle: "Please try again",
        type: "danger",
      });
    }
  };
</script>

<div class="keypad-view">
  <button
    class="close-modal"
    onclick={handleClose}
    type="button"
    aria-label="Close keypad"
  >
    <i class="fa-solid fa-circle-xmark"></i>
  </button>

  <KeypadUI
    bind:value={diallerState.keypadInputDigits}
    placeholder="Enter digits"
    onDigitPress={handleDigitPress}
    showInput={false}
  />
</div>
